import BooleanField from './BooleanField';

export default BooleanField;
